var map = {
	"./ACGIH-Heavy": 440,
	"./ACGIH-Heavy.json": 440,
	"./ACGIH-Light": 441,
	"./ACGIH-Light.json": 441,
	"./ACGIH-Moderate": 442,
	"./ACGIH-Moderate.json": 442,
	"./ACSM-Acclimatized": 443,
	"./ACSM-Acclimatized.json": 443,
	"./ACSM-NonAcclimatized": 444,
	"./ACSM-NonAcclimatized.json": 444,
	"./GaStateHighSchool": 445,
	"./GaStateHighSchool.json": 445,
	"./KyStateHighSchool": 446,
	"./KyStateHighSchool.json": 446,
	"./NATA": 447,
	"./NATA.json": 447,
	"./NcStateHighSchool": 448,
	"./NcStateHighSchool.json": 448,
	"./NjStateHighSchool": 449,
	"./NjStateHighSchool.json": 449,
	"./TBMed507-Easy": 450,
	"./TBMed507-Easy.json": 450,
	"./TBMed507-Hard": 451,
	"./TBMed507-Hard.json": 451,
	"./TBMed507-Moderate": 452,
	"./TBMed507-Moderate.json": 452,
	"./UsaSoccer-Cat1": 453,
	"./UsaSoccer-Cat1.json": 453,
	"./UsaSoccer-Cat2": 454,
	"./UsaSoccer-Cat2.json": 454,
	"./UsaSoccer-Cat3": 455,
	"./UsaSoccer-Cat3.json": 455,
	"./VtStateHighSchool": 456,
	"./VtStateHighSchool.json": 456,
	"./_HeatStressGuidelinesIndex": 355,
	"./_HeatStressGuidelinesIndex.json": 355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;